import React from 'react';
import { useTranslation } from 'react-i18next';

const HandoffUnavailable: React.FC<{ account: string | null }> = ({
  account,
}) => {
  const { t } = useTranslation();
  return (
    <div className="xc-notice xc-notice--warn" role="alert">
      {account
        ? t('forms.handoffUnavailable')
        : t('forms.handoffUnavailableNoAccount')}
      {account && (
        <>
          {' '}
          <a
            href={`https://shopify.com/${account}/account/orders`}
            target="_self"
          >
            {t('forms.handoffAccount')}
          </a>
        </>
      )}
    </div>
  );
};
export default HandoffUnavailable;
